export function getOwnProperty(o, key, fallback) {
  return Object.prototype.hasOwnProperty.call(o, key) ? o[key] : fallback !== undefined ? fallback : undefined;
}